import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CacheService } from 'projects/common/src/app/services/cache.service';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { Logger } from 'projects/common/src/app/classes/logger';
import { CommunicationService } from 'src/app/services/communication';
import { IUser } from 'projects/common/src/app/interfaces';
import { ParameterHandlerService } from 'projects/common/src/app/services';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({ providedIn: 'root' })
export class ReportVitalSignsService extends Logger {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    private cacheService: CacheService,
    private communicationService: CommunicationService,
    private parameterService: ParameterHandlerService,
    private urlBuilder: UrlBuilderService,
  ) {
    super();
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   *  Function to check if there it is data
   */
  public getVitalSignsData(selectedFilters: IOutputFilter): Promise<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.baseUrl}/Report/`;
    return this.communicationService.get(url, params).toPromise();
  }

  /**
   * Function to get report excel
   */
  public getVitalSignsReport(selectedFilters: IOutputFilter): Promise<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.urlBuilder.apiUrl}/Report/GetVitalSignReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).toPromise();
  }
  /**
   * Function to get report excel info
   */
  public getVitalSignsReportInfo(selectedFilters: IOutputFilter): Promise<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.urlBuilder.apiUrl}/Report/GetVitalSignReportDocumentInfo`;
    return this.http.get(url, { params }).toPromise();
  }

  /**
   * Function to set params and send selected filters to request
   *
   * @param selectedFilters Filters selected to save params
   */
  public setParams(selectedFilters: IOutputFilter): any {
    const companyId = this.cacheService.local('session').user.company.id;

    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      machineTypeId: selectedFilters.machineTypeId,
      machineList: selectedFilters.machineId,
      companyId,
    };
  }

  /**
   * Function to get machines for vital signs filter selector
   */
  public getMachinesForVitalSigns(machineType: number): Promise<any[]> {
    const user = this.parameterService.parameters.item('user-data')
      ? (this.parameterService.parameters.item('user-data').value as IUser)
      : ({ company: { id: 0 } } as IUser);
    const params = { companyId: user.company.id, machineType };

    const url = `${this.baseUrl}/Report/GetMachinesForVitalSignsFilter`;
    return this.communicationService.get(url, params).toPromise();
  }

  public getVitalSignsExcel(params: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetVitalSignsExcel`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }
}
